import { INITIAL_DATE } from "../../utils/constants";
import { formatDateFromAPI } from "../../utils/formatDate";
import { SAVE_SUPPLEMENTARY_INFO } from "../constant";

export const supplementaryInitialState = (data) => ({
	nameRegNoConfirmation: {},
	StudentTypeId: data?.studentTypeId,
	StudentType: data?.studentType,
	applicationTypeId: data?.applicationTypeId ?? null,
	passport: {
		passport: data?.passport
	},
	programmeInfo: {
		regNo: data?.regNumber,
		utmeScore: data?.programmeInfoResponse?.utmeScore,
		...(data?.programmeInfoResponse?.faculty && {
			faculty: {
				label: data?.programmeInfoResponse?.faculty,
				value: data?.programmeInfoResponse?.facultyId
			}
		}),
		...(data?.programmeInfoResponse?.facultyShoppingInto && {
			facultyShoppingInto: {
				label: data?.programmeInfoResponse?.facultyShoppingInto,
				value: data?.programmeInfoResponse?.facultyShoppingIntoId
			}
		}),
		...(data?.programmeInfoResponse?.department && {
			department: {
				label: data?.programmeInfoResponse?.department,
				value: data?.programmeInfoResponse?.departmentId
			}
		}),
		...(data?.programmeInfoResponse?.departmentOption && {
			departmentOption: {
				label: data?.programmeInfoResponse?.departmentOption,
				value: data?.programmeInfoResponse?.departmentOptionId
			}
		}),
		...(data?.programmeInfoResponse?.courseShoppingInto && {
			courseShoppingInto: {
				label: data?.programmeInfoResponse?.courseShoppingInto,
				value: data?.programmeInfoResponse?.courseShoppingIntoId
			}
		}),
		supplementaryApplicationDate:
			data?.programmeInfoResponse?.supplementaryApplicationDate,
		rrr: data?.personalInfoResponse?.rrr,
		...(data?.programmeInfoResponse?.firstSubject && {
			firstSubject: {
				label: data?.programmeInfoResponse?.firstSubject,
				value: data?.programmeInfoResponse?.firstSubjectId
			}
		}),
		...(data?.programmeInfoResponse?.secondSubject && {
			secondSubject: {
				label: data?.programmeInfoResponse?.secondSubject,
				value: data?.programmeInfoResponse?.secondSubjectId
			}
		}),
		...(data?.programmeInfoResponse?.thirdSubject && {
			thirdSubject: {
				label: data?.programmeInfoResponse?.thirdSubject,
				value: data?.programmeInfoResponse?.thirdSubjectId
			}
		}),
		...(data?.programmeInfoResponse?.fourthSubject && {
			fourthSubject: {
				label: data?.programmeInfoResponse?.fourthSubject,
				value: data?.programmeInfoResponse?.fourthSubjectId
			}
		})
	},
	personalInfo: {
		firstName: data?.personalInfoResponse?.firstname,
		middleName: data?.personalInfoResponse?.middlename,
		surName: data?.personalInfoResponse?.surname,
		...(data?.personalInfoResponse?.dateOfBirth && {
			dateOfBirth:
				data?.personalInfoResponse?.dateOfBirth === INITIAL_DATE
					? ""
					: formatDateFromAPI(data?.personalInfoResponse?.dateOfBirth)
		}),
		...(data?.personalInfoResponse?.gender && {
			sex: {
				label: data?.personalInfoResponse?.gender,
				value: data?.personalInfoResponse?.genderId
			}
		}),
		mobileNo: data?.personalInfoResponse?.mobileNumber,
		email: data?.personalInfoResponse?.email,
		nin: data?.personalInfoResponse?.nin,
		contactAddress: data?.personalInfoResponse?.contactAddress,

		...(data?.personalInfoResponse?.country && {
			country: {
				label: data?.personalInfoResponse?.country,
				value: data?.personalInfoResponse?.countryId
			}
		}),
		...(data?.personalInfoResponse?.state && {
			state: {
				label: data?.personalInfoResponse?.state,
				value: data?.personalInfoResponse?.stateId
			}
		}),
		...(data?.personalInfoResponse?.lga && {
			lga: {
				label: data?.personalInfoResponse?.lga,
				value: data?.personalInfoResponse?.lgaId
			}
		}),
		rrr: data?.personalInfoResponse?.rrr,
		disability: data?.personalInfoResponse?.disability,
		sponsorFullName: data?.personalInfoResponse?.sponsorFullName,
		sponsorContactAddress:
			data?.personalInfoResponse?.sponsorContactAddress,
		sponsorMobileNumber: data?.personalInfoResponse?.sponsorMobileNumber,
		...(data?.personalInfoResponse?.sponsorRelationship && {
			sponsorRelationship: {
				label: data?.personalInfoResponse?.sponsorRelationship,
				value: data?.personalInfoResponse?.sponsorRelationshipId
			}
		})
	},
	oLevelResult: {
		sittings: (data?.olevelResponse ?? []).map((item) => ({
			...item,
			resultPin: item?.resultPin,
			resultSerialNumber: item?.resultSerialNumber,
			examNumber: item?.examNumber,
			examCentre: item?.examCenter,
			...(item?.examinationType && {
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				}
			}),
			...(item?.examYear && {
				examYear: { value: item?.examYear, label: item?.examYear }
			}),
			subjects: [
				...Object.keys(item?.subjectGrade ?? {}).map((key, index) => ({
					...(key?.toUpperCase() && Object.keys(item?.subjectGradeId ?? {})?.[index] && {
						subject: {
							label: key?.toUpperCase(),
							value: Object.keys(item?.subjectGradeId ?? {})?.[index]
						}
					}),
					...(item?.subjectGrade?.[key] && Object.values(item?.subjectGradeId ?? {})?.[index] && {
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object.values(item?.subjectGradeId ?? {})?.[index]
						}
					})
				}))
			]
		}))
	},
	applicantId: data?.olevelResponse?.[0]?.applicationFormId
});

export const supplementaryPutmeInitialState = (data) => ({
	nameRegNoConfirmation: {},
	StudentTypeId: data?.studentTypeId,
	StudentType: data?.studentType,
	applicationTypeId: data?.applicationTypeId ?? null,
	passport: {
		passport: data?.passport
	},
	programmeInfo: {
		regNo: data?.regNumber,
		utmeScore: data?.programmeInfoResponse?.utmeScore,
		...(data?.programmeInfoResponse?.faculty && {
			faculty: {
				label: data?.programmeInfoResponse?.faculty,
				value: data?.programmeInfoResponse?.facultyId
			}
		}),
		...(data?.programmeInfoResponse?.facultyShoppingInto && {
			facultyShoppingInto: {
				label: data?.programmeInfoResponse?.facultyShoppingInto,
				value: data?.programmeInfoResponse?.facultyShoppingIntoId
			}
		}),
		...(data?.programmeInfoResponse?.department && {
			department: {
				label: data?.programmeInfoResponse?.department,
				value: data?.programmeInfoResponse?.departmentId
			}
		}),
		...(data?.programmeInfoResponse?.departmentOption && {
			departmentOption: {
				label: data?.programmeInfoResponse?.departmentOption,
				value: data?.programmeInfoResponse?.departmentOptionId
			}
		}),
		...(data?.programmeInfoResponse?.courseShoppingInto && {
			courseShoppingInto: {
				label: data?.programmeInfoResponse?.courseShoppingInto,
				value: data?.programmeInfoResponse?.courseShoppingIntoId
			}
		}),
		supplementaryApplicationDate:
			data?.programmeInfoResponse?.supplementaryApplicationDate,
		rrr: data?.personalInfoResponse?.rrr
	},
	personalInfo: {
		firstName: data?.personalInfoResponse?.firstname,
		middleName: data?.personalInfoResponse?.middlename,
		surName: data?.personalInfoResponse?.surname,
		...(data?.personalInfoResponse?.dateOfBirth && {
			dateOfBirth:
				data?.personalInfoResponse?.dateOfBirth === INITIAL_DATE
					? ""
					: formatDateFromAPI(data?.personalInfoResponse?.dateOfBirth)
		}),
		...(data?.personalInfoResponse?.gender && {
			sex: {
				label: data?.personalInfoResponse?.gender,
				value: data?.personalInfoResponse?.genderId
			}
		}),
		mobileNo: data?.personalInfoResponse?.mobileNumber,
		email: data?.personalInfoResponse?.email,
		nin: data?.personalInfoResponse?.nin,
		contactAddress: data?.personalInfoResponse?.contactAddress,

		...(data?.personalInfoResponse?.country && {
			country: {
				label: data?.personalInfoResponse?.country,
				value: data?.personalInfoResponse?.countryId
			}
		}),
		...(data?.personalInfoResponse?.state && {
			state: {
				label: data?.personalInfoResponse?.state,
				value: data?.personalInfoResponse?.stateId
			}
		}),
		...(data?.personalInfoResponse?.lga && {
			lga: {
				label: data?.personalInfoResponse?.lga,
				value: data?.personalInfoResponse?.lgaId
			}
		}),
		rrr: data?.personalInfoResponse?.rrr,
		disability: data?.personalInfoResponse?.disability,
		sponsorFullName: data?.personalInfoResponse?.sponsorFullName,
		sponsorContactAddress:
			data?.personalInfoResponse?.sponsorContactAddress,
		sponsorMobileNumber: data?.personalInfoResponse?.sponsorMobileNumber,
		...(data?.personalInfoResponse?.sponsorRelationship && {
			sponsorRelationship: {
				label: data?.personalInfoResponse?.sponsorRelationship,
				value: data?.personalInfoResponse?.sponsorRelationshipId
			}
		})
	},
	oLevelResult: {
		sittings: (data?.olevelResponse ?? []).map((item) => ({
			...item,
			resultPin: item?.resultPin,
			resultSerialNumber: item?.resultSerialNumber,
			examNumber: item?.examNumber,
			examCentre: item?.examCenter,
			...(item?.examinationType && {
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				}
			}),
			...(item?.examYear && {
				examYear: { value: item?.examYear, label: item?.examYear }
			}),
			subjects: [
				...Object.keys(item?.subjectGrade ?? {}).map((key, index) => ({
					...(key?.toUpperCase() && Object.keys(item?.subjectGradeId ?? {})?.[index] && {
						subject: {
							label: key?.toUpperCase(),
							value: Object.keys(item?.subjectGradeId ?? {})?.[index]
						}
					}),
					...(item?.subjectGrade?.[key] && Object.values(item?.subjectGradeId ?? {})?.[index] && {
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object.values(item?.subjectGradeId ?? {})?.[index]
						}
					})
				}))
			]
		}))
	},
	applicantId: data?.olevelResponse?.[0]?.applicationFormId
});

export const supplementaryReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_SUPPLEMENTARY_INFO:
			return action.payload;
		default:
			return state;
	}
};
